export default function About() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>About Us</h2>
      <p>About Us – Nawabi Bites

Welcome to Nawabi Bites, your trusted brand for premium-quality Mathri and traditional snacks.

We are passionate about:

Authentic taste

Premium quality ingredients

Hygienic preparation

Fast delivery across India

Our mission is to bring the taste of traditional Nawabi flavours to your home.</p>
    </div>
  );
}
